<template>
  <div class="search-flex">
    <div>
      <el-form :inline="true" :model="searchParams" size="small" label-width="88px">
        <el-form-item>
          <el-input v-model="searchParams.templateName" placeholder="提示名称"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <div class="search-btn">
      <!-- 搜索按钮 -->
      <el-button v-auth="'PROMPT_TEMPLATE_SEARCH'" type="primary" size="small" @click="search(1)">搜索</el-button>
      <!-- 新增按钮 -->
      <el-button v-auth="'PROMPT_TEMPLATE_ADD'" size="small" @click="add">新增</el-button>
    </div>
    <EditDialog ref="editDialog" @reload="search()"></EditDialog>
  </div>
</template>

<script>
import { ullHitTemplatePage } from "@/api/apps/securityPolicy";
import EditDialog from "./edit.vue";
import Message from "@/components/Message";
export default {
  name: "WebSaaSSearch",
  components: {
    EditDialog,
  },
  props: {
    displayPage: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  inject: ["searchParams", "list"],
  methods: {
    // 新增
    add() {
      this.$refs.editDialog.show();
    },
    // 搜索
    async search(opt) {
      this.searchParams.current = 1;
      const params = { ...this.searchParams };
      console.log("搜索的参数", params);
      const { data } = await ullHitTemplatePage(params);
      console.log("搜索的响应", data);
      this.list.value = data.data.records;
      this.searchParams.total = data.data.total;
      opt ? Message.success("搜索成功") : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;

  align-items: flex-start;
}

.search-btn {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
</style>